import React from "react";
import { Grid2, Typography } from "@mui/material";
import useAlert from "./context";
import { Button } from "@aidergroup/ui-v2";
import { i18n } from "@/utils/i18n";
import { Styled } from "./styles";

const Alert: React.FC = () => {
    const { visible, title, message, close, actions } = useAlert();

    const onCancel = () => {
        const action = actions?.cancel?.callback;
        action?.();
        close();
    };

    const onConfirm = () => {
        const action = actions?.confirm?.callback;

        action?.();
        close();
    };

    return (
        <Styled.Modal open={visible} onClose={close}>
            <Styled.Container container spacing={3}>
                <Grid2 size={{ xs: 12 }}>
                    <Typography variant="h3" textAlign="left" fontWeight="bold">
                        {title}
                    </Typography>
                </Grid2>
                {message && (
                    <Grid2 size={{ xs: 12 }}>
                        <Typography variant="body2" textAlign="left">
                            {message}
                        </Typography>
                    </Grid2>
                )}
                <Grid2
                    container
                    size={{ xs: 12 }}
                    display="flex"
                    alignItems="center"
                    justifyContent="flex-end"
                    spacing={2}
                >
                    <Button variant="outlined" color="error" onClick={onCancel}>
                        {actions?.cancel?.title ?? i18n.t("button.cancel")}
                    </Button>
                    <Button variant="contained" color="primary" onClick={onConfirm}>
                        {actions?.confirm?.title ?? i18n.t("button.confirm")}
                    </Button>
                </Grid2>
            </Styled.Container>
        </Styled.Modal>
    );
};

export default Alert;
